exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#mycontainer {\r\n  position:fixed;\r\n  top:50%;\r\n  transform:translateY(-50%);\r\n  width:100%;\r\n}\r\n\r\n#mycontainer p {\r\n\r\n  color:#2035ac;\r\n  font-size:40px;\r\n  font-weight:bold;\r\n\r\n\r\n}\r\n\r\n\r\n\r\n#mycontainer .row:not(:first-child){\r\n  padding-top:20px;\r\n}\r\n\r\n\r\n\r\n#mycontainer span {\r\n\r\n  color:#921246;\r\n  font-size:18px;\r\n\r\n\r\n}\r\n\r\n.btn-theme {\r\n  border-radius: 8px !important;\r\n  color: white !important;\r\n  background: #951246;\r\n  width: 100%;\r\n  max-width: 200px;\r\n  padding: 5px !important;\r\n}\r\n\r\n\r\n@media only screen and (min-width:320px) and (max-width:768px){\r\n  #mycontainer p {\r\n    font-size:27px;\r\n  }\r\n\r\n  #mycontainer {\r\n  margin-left:-15px;\r\n  }\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Thakur/github/Stratgist-latest/Stratgist LandingPage/src/app/thank-you/thank-you.component.css
// module id = ../../../../../src/app/thank-you/thank-you.component.css
// module chunks = 2